import React, { useContext, useCallback } from 'react';
import proptypes from 'prop-types';
const { string, bool } = proptypes;
import {
  QueryProvider,
  QueryContext,
  extend
} from '@thd-nucleus/data-sources';
import { useStore } from '@thd-nucleus/experience-context';
import { Col, Row } from '@thd-olt-component-react/grid';
import { Heading } from '@thd-olt-component-react/heading';
import { Carousel } from '@thd-olt-component-react/core-ui';
import { ShopByRoomPod } from '../shop-by-room/ShopByRoomPod';
import { CurationDataModel } from './CurationDataModel';
import { curationSkipFn } from '../CollectionHelpers';
import { useCuration } from './useCuration';
import { propTypes, defaultProps } from './CurationPropTypes';
import './curation.scss';

export const CurationDesktop = ({ curationId = '', preview }) => {
  const { isClientResolved, defaultVariables } = useContext(QueryContext);
  const store = useStore();
  const { storeId } = store;

  const [metadata, carouselProducts, getMoreCurationItems] = useCuration({
    curationId, storeId, preview
  });

  const { name, productCount } = metadata || {};
  const { allProducts } = productCount || {};
  const totalItems = Number(allProducts) || 0;

  const shouldSkip = (opts) => {
    return curationSkipFn(opts, { isClientResolved });
  };

  if (!carouselProducts?.length) {
    return null;
  }

  return (
    <div className="curation">
      <div className="curation__title">
        <Heading underline>
          {name || ''} <span className="curation__title--count">({totalItems})</span>
        </Heading>
      </div>
      <Row>
        <Col>
          <QueryProvider
            dataSource="Collection"
            defaultVariables={{
              skipSubscribeAndSave: true,
              skipSpecificationGroup: true,
              storeId,
              skipKPF: true,
              ...(typeof defaultVariables?.current?.isBrandPricingPolicyCompliant === 'boolean'
                && { isBrandPricingPolicyCompliant:
                  defaultVariables.current.isBrandPricingPolicyCompliant })
            }}
            skip={shouldSkip}
            cacheKey="curation-desktop"
          >
            <Carousel
              onSlideNextTransitionStart={getMoreCurationItems}
            >
              {
                (carouselProducts || []).map((sku, index) => (
                  <ShopByRoomPod
                    key={sku.itemId}
                    itemId={sku.itemId}
                    hideLimitPerOrder
                    hidePriceBadge
                    hideSavingsText
                    hideFulfillment
                    storeId={storeId}
                    position={index}
                    parent="shopbyroom"
                  />
                ))
              }
            </Carousel>
          </QueryProvider>
        </Col>
      </Row>
    </div>
  );
};

CurationDesktop.displayName = 'CurationDesktop';

CurationDesktop.dataModel = extend({}, CurationDataModel, ShopByRoomPod);

CurationDesktop.propTypes = propTypes;

CurationDesktop.defaultProps = defaultProps;
